import {useEffect} from "react";
import {
  Button,
  Modal,
  Box,
  Typography,
  Divider,
  Stack,
} from "@mui/material";
import PropTypes from "prop-types";
import "./InFormGenericModal.css";
const LightGrayAlien = "#f8f8f8";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function InFormGenericModal({
  openFlag,
  openMethod,
  closeMethod,
  buttonMethod,
  titleText,
  displayButton = true,
  displayCancelButton = false,
  buttonText = "Close",
  children,
  width = "auto",
  overflow = 'auto',
  height = 'auto',
  escapeCanCloseModal = true
}) {

  const buttonTextLength = buttonText ? buttonText.length : 0;
  const percentMarginLeft = 87 - buttonTextLength;
  const percentMarginLeftText = percentMarginLeft.toString() + '%';

  useEffect(() => {
    if(openMethod && openFlag)
    {
      openMethod();
    }
  }, [openFlag])

  return (
    <Modal
      open={openFlag}
      onClose={closeMethod}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      disableEscapeKeyDown={!escapeCanCloseModal}
    >
      <Box sx={style} width={width} overflow={overflow} height={height}>
        <Typography id="modal-modal-title" variant="h6" component="h2" textAlign={'center'} sx={{fontWeight: 'bold'}}>
          {titleText}
        </Typography>

        <Divider orientation="horizontal" flexItem style={{backgroundColor: LightGrayAlien}} />

        {children}

        <Stack direction={"row"} sx={{marginLeft: `${percentMarginLeftText}`, marginRight: '5px', marginBottom: '5px'}}>
          {displayCancelButton ? 
            <Button onClick={closeMethod}>
            Cancel
            </Button>
          : null}

          {displayButton ? 
            <Button onClick={buttonMethod} variant="outlined">
            {buttonText}
            </Button>
          : null}
        </Stack>
      </Box>
    </Modal>
  );
}

InFormGenericModal.propTypes = {
  openFlag: PropTypes.bool,
  closeMethod: PropTypes.func,
  buttonMethod: PropTypes.func,
  titleText: PropTypes.string,
  contentTExt: PropTypes.string,
};
